// src/components/DocumentUpload.jsx
import React, { useState } from "react";

import api from "../services/api";

const options = [
  "Passport photo",
  "ID card - NIN",
  "ID card - Voters card",
  "ID card - Drivers license",
  "ID card - International passport",
  "Utility bill",
  "Signature mandate",
  "Others",
];

const DocumentUpload = () => {
  const [selectedType, setSelectedType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");

  const handleUpload = async () => {
    if (!selectedType || !selectedFile) {
      setMessage("Please choose both a document type and a file.");
      return;
    }

    const payload = new FormData();
    payload.append("doc_type", selectedType);
    payload.append("document_type", selectedType);
    payload.append("file", selectedFile);

    try {
      setUploading(true);
      const response = await api.uploadDocument(payload);
      setMessage(response?.message || "Upload successful.");
      setSelectedType("");
      setSelectedFile(null);
    } catch (error) {
      console.error("Upload error", error);
      setMessage(error?.message || "Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mx-auto mt-10 max-w-md rounded-2xl bg-white p-6 shadow-xl">
      <h2 className="text-xl font-semibold text-slate-900">Upload a document</h2>
      <p className="mt-2 text-sm text-slate-500">Select the document type and upload a clear copy.</p>

      <div className="mt-6 space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">Document type</label>
          <select
            value={selectedType}
            onChange={(event) => setSelectedType(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-100"
          >
            <option value="">Select type</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm font-medium text-slate-700">Document file</label>
          <input
            type="file"
            onChange={(event) => setSelectedFile(event.target.files?.[0] || null)}
            className="mt-1 w-full text-sm text-slate-600"
            accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
          />
        </div>
      </div>

      <button
        onClick={handleUpload}
        disabled={uploading}
        className="mt-6 w-full rounded-lg bg-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-600/20 transition hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-300 disabled:cursor-not-allowed disabled:bg-emerald-400"
      >
        {uploading ? "Uploading..." : "Upload"}
      </button>

      {message && (
        <p className="mt-4 text-sm text-slate-600">{message}</p>
      )}
    </div>
  );
};

export default DocumentUpload;
